import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ComponentsModule, DirectiveModule, PipesModule } from '@fcom/common';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';

import { CommonServiceFormsModule } from './components/common/common-service-forms.module';
import { RadioListComponent } from './components/radio-list/radio-list.component';
import { PrefillService } from './services/prefill.service';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    CommonServiceFormsModule,
    UiComponentsModule,
    UiTranslateModule,
  ],
  declarations: [RadioListComponent],
  exports: [RadioListComponent],
  providers: [PrefillService],
})
export class ServiceFormsModule {}
